
import { Link } from "@material-ui/core";

export default function CategoryLinks() {
    return (
      <>
        <div className="row mob-row5">
          <div className="col-md-3 col-6 mb-2">
            <Link href="/sell-used-mobile-phones">
              <a className="bg-default-blue text-white p-3 w-100 h-100 rounded d-flex flex-column align-items-center justify-content-center gap-1 text-center">
                <div className="">
                  <img className="w-100" src="/images/sell-mob.svg" />
                </div>
                <small className="text-white">Sell Used Mobiles</small>
              </a>
            </Link>
          </div>
          <div className="col-md-3 col-6 mb-2">
            <Link href="/sell-used-tablets">
              <a className="bg-default-blue text-white p-3 w-100 h-100 rounded d-flex flex-column align-items-center justify-content-center gap-1 text-center">
                <div className="">
                  <img className="w-100" src="/images/sell-tab.svg" />
                </div>
                <small className="text-white">Sell Used Tablets</small>
              </a>
            </Link>
          </div>
          <div className="col-md-3 col-6 mb-2">
            <Link href="/sell-used-laptops">
              <a className="bg-default-blue text-white p-3 w-100 h-100 rounded d-flex flex-column align-items-center justify-content-center gap-1 text-center">
                <div className="">
                  <img className="w-100" src="/images/sell-lap.svg" />
                </div>
                <small className="text-white">Sell Used Laptops</small>
              </a>
            </Link>
          </div>
          <div className="col-md-3 col-6 mb-2">
            <Link href="/sell-used-othergadgets">
              <a className="bg-default-blue text-white p-3 w-100 h-100 rounded d-flex flex-column align-items-center justify-content-center gap-1 text-center">
                <div className="">
                  <img className="w-100" src="/images/sell-Gadgets.svg" />
                </div>
                <small className="text-white">Sell Other Gadgets</small>
              </a>
            </Link>
          </div>
        </div>
      </>
    );
}
